import React from "react";
import ChartReport from "./Report";

const VendorChart = ({ lastMonthData }) => {
  return (
    <>
      <ChartReport lastMonthData={lastMonthData} title="Vendors" dataKey="vendorCount" />

    </>
  );
};

export default VendorChart;
